<div *ngIf="visible" id="message-template-selector" class="form-field required">
  <label>Modèle de message</label>
  <div class="d-flex w-100 justify-content-between">
    <select (ngModelChange)="onChangeMessageTemplate($event)"
            [ngModel]="currentMessageTemplate"
            class="form-control custom-select fs14px"
            [class.no-right-border-radius]="currentMessageTemplate.id.toValue() > 0">
      <option [ngValue]="defaultMessageTemplate">Modèle prédéfini</option>
      <option [ngValue]="emptyMessageTemplate">Nouveau modèle vierge</option>
      <option *ngIf="messagesTemplates && messagesTemplates.length > 0" disabled> ───────────────────</option>
      <option *ngFor="let m of messagesTemplates" [ngValue]="m">Modèle n°{{ m.id }}</option>
    </select>
    <div>
      <button *ngIf="currentMessageTemplate.id.toValue() > 0" (click)="deleteTemplate(currentMessageTemplate)"
              class="btn btn-outline-primary btn-outline icon-only no-left-border-radius"
              dropdownToggle
              type="button">
        <i i-bs name="trash" width="12" height="12"></i>
      </button>
    </div>
  </div>
</div>

<div *ngIf="visible" id="message-template-text" class="form-field required">
  <label>Texte du message</label>
  <textarea (ngModelChange)="onChangeMessageTemplateContent($event, withSign)"
            [class.is-invalid]="currentMessageTemplate.content.length === 0"
            [maxRows]="maxRows"
            [minRows]="minRows"
            [ngModel]="currentMessageTemplate.content"
            aria-describedby="content"
            autosize
            class="form-control"
            id="message-textarea"
            placeholder="Écrivez le texte du message"
            type="text"></textarea>

  <small class="grey2">
    {{
      currentMessageTemplate.id.toValue() === -1
        ? 'Le modèle sera sauvegardé et utilisé dans le message envoyé.'
        : 'Les modifications seront utilisées dans le message envoyé, mais ne seront pas sauvegardées.'
    }}
  </small>
</div>

<div *ngIf="visible" id="message-template-sign" class="form-field">
  <div id="with-sign" class="form-check">
    <input [(ngModel)]="withSign"
           (ngModelChange)="onChangeMessageTemplateContent(currentMessageTemplate.content, $event)"
           class="form-check-input"
           id="with-sign-checkbox"
           type="checkbox">
    <label class="form-check-label" for="with-sign-checkbox">
      Ajouter la signature
    </label>
  </div>
  <textarea *ngIf="withSign"
            [ngModel]="sign"
            [disabled]="true"
            aria-describedby="content"
            class="form-control mt-2 disabled"
            style="overflow:hidden"
            type="text">
  </textarea>
  <small *ngIf="withSign" class="grey2">Cette signature sera apposée en fin de message.</small>
</div>
